import ExcelJS from "exceljs";

/** Tên sheet dữ liệu — backend ưu tiên đọc sheet này */
export const COURSE_ASSIGN_IMPORT_DATA_SHEET = "Danh sách";

const thinBorder = {
  top: { style: "thin", color: { argb: "FFD1D5DB" } },
  left: { style: "thin", color: { argb: "FFD1D5DB" } },
  bottom: { style: "thin", color: { argb: "FFD1D5DB" } },
  right: { style: "thin", color: { argb: "FFD1D5DB" } },
};

export const COURSE_ASSIGN_IMPORT_COLS = [
  {
    header: "Email",
    width: 32,
    required: true,
    format: "Email đăng nhập của nhân viên / GV trong chi nhánh đã chọn",
    example: "gv.a@truongxyz.edu.vn",
    note: "Ưu tiên dùng Email. Phải thuộc nhân viên active trong đúng chi nhánh đang gán.",
  },
  {
    header: "Mã NV",
    width: 16,
    required: false,
    format: "Mã nhân sự (code)",
    example: "GV-001",
    note: "Dùng khi không có Email. Nếu có Email thì bỏ qua cột này.",
  },
  {
    header: "Mã khóa học",
    width: 48,
    required: true,
    format: "Một hoặc nhiều mã khóa, cách nhau bởi , ; hoặc |",
    example: "MATH-G1, MATH-G2, ENG-G1",
    note: "Mã phải nằm trong phạm vi khóa gán được của chi nhánh (cùng mã trên danh mục khóa học).",
  },
];

const DATA_ENTRY_ROWS = 80;

const SAMPLE_ROWS = [
  ["gv.a@truongxyz.edu.vn", "GV-001", "MATH-G1, MATH-G2"],
  ["gv.b@truongxyz.edu.vn", "", "ENG-G1; ENG-G2"],
  ["", "GV-003", "SCI-G1"],
];

function styleTitleCell(cell, { size = 15, color = "FF7F1D1D", bg = "FFFEE2E2" } = {}) {
  cell.font = { bold: true, size, color: { argb: color } };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
  cell.border = thinBorder;
}

function styleSectionTitle(cell) {
  cell.font = { bold: true, size: 12, color: { argb: "FFB91C1C" } };
  cell.alignment = { vertical: "middle", wrapText: true };
}

function styleBodyCell(cell, { bold = false, italic = false, bg = null } = {}) {
  cell.font = { size: 11, bold, italic, color: { argb: "FF374151" } };
  cell.alignment = { vertical: "top", wrapText: true };
  if (bg) {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  }
  cell.border = thinBorder;
}

function buildGuideSheet(wb) {
  const ws = wb.addWorksheet("Hướng dẫn", {
    views: [{ state: "frozen", ySplit: 1 }],
    properties: { defaultRowHeight: 18 },
  });
  const ncol = 6;
  ws.columns = [
    { width: 4 },
    { width: 22 },
    { width: 12 },
    { width: 44 },
    { width: 36 },
    { width: 52 },
  ];

  let r = 1;
  ws.mergeCells(r, 1, r, ncol);
  const t = ws.getCell(r, 1);
  t.value = "HƯỚNG DẪN GÁN KHÓA HỌC THEO NHÂN VIÊN (EXCEL)";
  styleTitleCell(t);
  ws.getRow(r).height = 36;
  r += 1;

  ws.mergeCells(r, 1, r, ncol);
  const sub = ws.getCell(r, 1);
  sub.value =
    "IMA Vietnam ERP — Nhập hàng loạt quyền xem khóa học cho giáo viên / nhân viên trong một chi nhánh. Phiên bản biểu mẫu: 2026.";
  sub.font = { italic: true, size: 10, color: { argb: "FF6B7280" } };
  sub.alignment = { horizontal: "center", wrapText: true };
  r += 2;

  const addSection = (title, lines) => {
    ws.mergeCells(r, 1, r, ncol);
    const c = ws.getCell(r, 1);
    c.value = title;
    styleSectionTitle(c);
    ws.getRow(r).height = 22;
    r += 1;
    for (const line of lines) {
      ws.mergeCells(r, 1, r, ncol);
      const lc = ws.getCell(r, 1);
      lc.value = line;
      styleBodyCell(lc);
      ws.getRow(r).height = line.length > 90 ? 38 : 20;
      r += 1;
    }
    r += 1;
  };

  addSection("I. QUY TRÌNH TRÊN HỆ THỐNG", [
    "Bước 1 — Mở «Khóa học» (E-learning) → «Gán khóa học» → chọn Chi nhánh.",
    "Bước 2 — Bấm «Nhập Excel» trong hộp thoại gán khóa.",
    "Bước 3 — Tải file mẫu này, mở sheet «Danh sách», mỗi dòng = một nhân viên.",
    "Bước 4 — Chọn chế độ: Cộng thêm khóa (mặc định) hoặc Thay thế toàn bộ quyền khóa của từng người trong file.",
    "Bước 5 — Lưu .xlsx và tải lên hệ thống.",
  ]);

  addSection("II. CÁCH NHẬP SHEET «DANH SÁCH»", [
    "• Giữ nguyên dòng tiêu đề và tên sheet «Danh sách».",
    "• Dòng trống hoàn toàn sẽ bỏ qua.",
    "• Cột có dấu * là bắt buộc theo logic: cần Email hoặc Mã NV, và bắt buộc có Mã khóa học.",
    "• Nhiều mã khóa trên một dòng: cách nhau bởi dấu phẩy, chấm phẩy hoặc |.",
    "• Tài khoản phải đã tồn tại (active) trong đúng chi nhánh đang chọn trên màn hình.",
  ]);

  ws.mergeCells(r, 1, r, ncol);
  ws.getCell(r, 1).value = "III. BẢNG MÔ TẢ CỘT";
  styleSectionTitle(ws.getCell(r, 1));
  ws.getRow(r).height = 22;
  r += 1;

  const hdr = ws.getRow(r);
  ["STT", "Tên cột", "Bắt buộc", "Định dạng / Giá trị", "Ví dụ", "Ghi chú"].forEach(
    (label, idx) => {
      const c = hdr.getCell(idx + 1);
      c.value = label;
      c.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
      c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFB91C1C" } };
      c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      c.border = thinBorder;
    }
  );
  hdr.height = 26;
  r += 1;

  COURSE_ASSIGN_IMPORT_COLS.forEach((col, idx) => {
    const row = ws.getRow(r);
    const vals = [
      idx + 1,
      col.required ? `${col.header} *` : col.header,
      col.required ? "Có*" : "Không",
      col.format,
      col.example,
      col.note,
    ];
    vals.forEach((val, ci) => {
      const c = row.getCell(ci + 1);
      c.value = val;
      styleBodyCell(c, { bg: idx % 2 === 0 ? "FFF9FAFB" : "FFFFFFFF" });
      c.alignment = {
        vertical: "top",
        wrapText: true,
        horizontal: ci === 0 ? "center" : "left",
      };
    });
    row.height = 48;
    r += 1;
  });
  r += 1;

  addSection("IV. CHẾ ĐỘ NHẬP", [
    "• Cộng thêm khóa (merge): giữ quyền cũ, chỉ thêm các mã trong file (không trùng).",
    "• Thay thế (replace): xóa hết quyền khóa hiện có của nhân viên đó rồi gán đúng danh sách trong dòng.",
    "• Khi mở trường mới: thường dùng «Cộng thêm» sau khi đã tạo tài khoản GV.",
  ]);

  addSection("V. LƯU Ý", [
    "• Hệ thống đọc sheet «Danh sách» (không đọc sheet Hướng dẫn).",
    "• Chi nhánh lấy từ màn hình — không nhập mã chi nhánh trong file.",
    "• Tạo tài khoản giáo viên hàng loạt: dùng import tài khoản GV (CRM); cột Mã khóa học ở đó cũng gán được lúc tạo mới.",
    "• Nhân viên chưa có quyền xem E-learning vẫn có thể được gán khóa; cần phân quyền role riêng nếu chưa có.",
  ]);

  return ws;
}

function buildDataSheet(wb) {
  const ws = wb.addWorksheet(COURSE_ASSIGN_IMPORT_DATA_SHEET, {
    views: [{ state: "frozen", ySplit: 1 }],
  });

  const headers = [
    "Email *",
    "Mã NV",
    "Mã khóa học *",
  ];

  const headerRow = ws.getRow(1);
  headers.forEach((h, idx) => {
    const col = idx + 1;
    const cell = headerRow.getCell(col);
    cell.value = h;
    cell.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFB91C1C" },
    };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = thinBorder;
    ws.getColumn(col).width = COURSE_ASSIGN_IMPORT_COLS[idx].width;
  });
  headerRow.height = 32;
  ws.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: headers.length },
  };

  // Dòng mẫu (in nghiêng) + dòng trống để nhập
  const allRows = [
    ...SAMPLE_ROWS,
    ...Array.from({ length: DATA_ENTRY_ROWS }, () => ["", "", ""]),
  ];

  allRows.forEach((vals, i) => {
    const rowNum = i + 2;
    const row = ws.getRow(rowNum);
    const isSample = i < SAMPLE_ROWS.length;
    vals.forEach((val, ci) => {
      const cell = row.getCell(ci + 1);
      cell.value = val || "";
      cell.border = thinBorder;
      cell.alignment = { vertical: "center", wrapText: true };
      if (isSample) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFBEB" },
        };
        cell.font = { size: 11, color: { argb: "FF92400E" }, italic: true };
      } else {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" },
        };
        cell.font = { size: 11, color: { argb: "FF111827" } };
      }
    });
    row.height = 22;
  });

  ws.getCell("A1").note = {
    texts: [
      {
        text: "Uu tien Email nhan vien / GV active trong chi nhanh dang chon. Xem sheet Huong dan.",
      },
    ],
  };
  ws.getCell("B1").note = {
    texts: [{ text: "Dung khi khong co Email." }],
  };
  ws.getCell("C1").note = {
    texts: [
      {
        text: "Nhieu ma khoa: cach nhau boi dau phay, cham phay hoac |. Xem sheet Huong dan.",
      },
    ],
  };

  return ws;
}

export async function buildCourseAssignImportTemplateBlob() {
  const wb = new ExcelJS.Workbook();
  wb.creator = "IMA Vietnam ERP";
  wb.created = new Date();
  wb.properties.date1904 = false;

  buildGuideSheet(wb);
  buildDataSheet(wb);

  const buffer = await wb.xlsx.writeBuffer();
  return new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}

export async function downloadCourseAssignImportTemplate() {
  const blob = await buildCourseAssignImportTemplateBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "mau_gan_khoa_hoc_theo_nhan_vien.xlsx";
  a.click();
  URL.revokeObjectURL(url);
}
